import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import useConvertDate from "../../../../global/utils/hooks/useConvertDate";
import { useToggle } from "../../../../global/utils/hooks/useToggle";

export default function TransitionCard({finance}) {
    const createDate = useConvertDate({date:finance.created_at, withHour: false});

    const [modal, setModal, toggleModal] = useToggle(false);

    const handleViewMoreClick = () => {
        setModal(true);
    }

  return (
    <>
        <Modal isOpen={modal} toggle={toggleModal}>
            <ModalHeader toggle={toggleModal}>
                {finance.payment_type}
            </ModalHeader>
            <ModalBody>
                <div className="d-flex flex-column">
                    <div className="mb-3">
                    <span className={`fw-bold me-2`}>
                        Finance Info:
                    </span>
                    <div className={`ms-2`}>
                        <span className={`fw-semibold me-2`}>
                            Date:
                        </span>
                        <span>
                            {createDate ? createDate : '-'}
                        </span>
                    </div>
                    <div className={`ms-2`}>
                        <span className={`fw-semibold me-2`}>
                            Credit:
                        </span>
                        <span>
                            {finance.credit ? finance.credit : '-'}
                        </span>
                    </div>
                    <div className={`ms-2`}>
                        <span className={`fw-semibold me-2`}>
                            Debit:
                        </span>
                        <span>
                            {finance.debit ? finance.debit : '-'}
                        </span>
                    </div>
                    <div className={`ms-2`}>
                        <span className={`fw-semibold me-2`}>
                            Description:
                        </span>
                        <span>
                            {finance.description ? finance.description : '-'}
                        </span>
                    </div>
                    </div>
                    <div className="mb-3">
                        <span className={`fw-bold me-2`}>
                            Bank Info:
                        </span>
                    <div className={`ms-2`} >
                        <span className={`fw-semibold me-2`}>
                            Bank name:
                        </span>
                        <span>
                            {finance.bank_name ? finance.bank_name : '-'}
                        </span>
                    </div>
                    <div className={`ms-2`} >
                        <span className={`fw-semibold me-2`}>
                            Bank response:
                        </span>
                        <span>
                            {finance.bank_response ? finance.bank_response : '-'}
                        </span>
                    </div>
                    <div className={`ms-2`} >
                        <span className={`fw-semibold me-2`}>
                            Payment id:
                        </span>
                        <span>
                            {finance.payment_id ? finance.payment_id : '-'}
                        </span>
                    </div>
                    <div className={`ms-2`} >
                        <span className={`fw-semibold me-2`}>
                            Payment type:
                        </span>
                        <span>
                            {finance.payment_type ? finance.payment_type : '-'}
                        </span>
                    </div>
                    <div className={`ms-2`} >
                        <span className={`fw-semibold me-2`}>
                            Reference number:
                        </span>
                        <span>
                            {finance.reference_number ? finance.reference_number : '-'}
                        </span>
                    </div>
                    <div className={`ms-2`} >
                        <span className={`fw-semibold me-2`}>
                            Trace  number:
                        </span>
                        <span>
                            {finance.trace_number ? finance.trace_number : '-'}
                        </span>
                    </div>
                    {/* <div className={`ms-2`} >
                        <span className={`fw-semibold me-2`}>
                            Type:
                        </span>
                        <span>
                            {finance.type ? finance.type : '-'}
                        </span>
                    </div> */}
                    </div>
                    {
                    finance.order &&
                        <div className="mb-3">
                        <span className={`fw-bold me-2`}>
                            Order Info:
                        </span>
                        <div className={`ms-2`}>
                            <span className={`fw-semibold me-2`}>
                                Order id:
                            </span>
                            <span>
                                {finance.order.id ? finance.order.id : '-'}
                            </span>
                        </div>
                        <div className={`ms-2`}>
                            <span className={`fw-semibold me-2`}>
                                Profuct id:
                            </span>
                            <span>
                                {finance.order.product_id ? finance.order.product_id : '-'}
                            </span>
                        </div>
                        <div className={`ms-2`}>
                            <span className={`fw-semibold me-2`}>
                                Order description:
                            </span>
                            <span>
                                {finance.order.description ? finance.order.description : '-'}
                            </span>
                        </div>
                        <div className={`ms-2`}>
                            <span className={`fw-semibold me-2`}>
                                Order status:
                            </span>
                            <span>
                                {finance.order.status ? finance.order.status : '-'}
                            </span>
                        </div>
                        </div>
                    }
                </div>
            </ModalBody>
        </Modal>
        <tr className={`${!finance.acknowledge ? 'table-danger' : ""}`} key={`finance-${finance.id}`}>
            <td>{createDate}</td>
            <td>{finance.description}</td>
            <td>{finance.credit}</td>
            <td>{finance.debit}</td>
            <td>
            <Button  
                id='viewMore'
                size="sm"
                onClick={handleViewMoreClick}
                >
                <i className="bi bi-eye text-tertiary"></i>
            </Button>
            </td>
        </tr>
    </>
  )
}
